module.exports = __webpack_public_path__ + "img/materials-2_jp.d25a657.jpg";